import axios from 'axios'
import { store } from 'src/client'
import {
  SpendChartRequestParams,
  SpendChartResponse,
} from 'src/queries/reporting/reporting.models'
import { selectAuthedJsonApiRequestConfig } from 'src/redux/selectors/axios.selectors'

export const fetchSpendChart = async ({
  chart,
  since,
  until,
  currency,
  // organizationId is used for query cache keying only; the auth bearer token scopes the response to the org
  organizationId: _organizationId,
}: SpendChartRequestParams): Promise<SpendChartResponse> => {
  const requestConfig = selectAuthedJsonApiRequestConfig(store.getState())
  const response = await axios.get<SpendChartResponse>(
    '/reporting/spend-dashboard',
    {
      ...requestConfig,
      params: {
        chart,
        since,
        until,
        currency,
      },
    },
  )
  return response.data
}
